export const CUSTOM_USER_ACCESS = {
  formsUploadSetting: 'form-upload-setting',
  formCloner: 'form-cloner',
  writebackSetup: 'form-wb-setup',
  sourceIdCorrection: 'form-wb-setup',
};
